// global/video/video.dom

function classesThumbVisibleColumnOnBlock(position, nThumbs) {
    element_class = "";

    for (columns = 5; columns >= 2; columns--) {
        if ((position <= columns) || (position <= (nThumbs - (nThumbs % columns))) || ((position % columns) == 0)) {
            element_class += " visible-col-" + columns;
        }
    }
    return element_class;
}

function addVideosDOM(data, home) {
    home = home || false;
    videos_size = data['videos'].length;
    element_class = "";

    $.each(data['videos'], function (index, value) {
        if (home) {
            element_class = classesThumbVisibleColumnOnBlock(index, videos_size);
        }
        switch (value.type) {
            case 'owner':
                var video = initEventsVideoThumb(createThumbOwner(value, element_class));
                break;
            case 'owner-pending':
                var video = createThumbOwnerPending(value);
                break;
            case 'owner-incomplete':
                var video = createThumbOwnerIncomplete(value);
                break;
            case 'owner-rejected':
                var video = createThumbOwnerRejected(value);
                break;
            case 'not-owner':
                var video = initEventsVideoThumb(createThumbNotOwner(value, element_class));
                break;
        }

        if (value.private) {
            $(video).find('thumb-video').addClass('private');
            $(video).find('[name="title"]').html('<span class="private-video-span">' + global_tokyvideo_text_private + '</span> ' + $(video).find('[name="title"]').html());
        }

        $('#videos-container').append(video).append('\n');
    });
}

function createThumbOwner(dataVideo) {
    var videoHtml = '<div class="thumb-video ' + element_class + '">' +
        '<a name="url" href="" class="thumb-duracion">' +
        '<img name="thumb" src=""  width="332px" height="186px">' +
        '<span class="duracion">' +
        '<span name="duration"></span>' +
        '</span>' +
        '</a>' +
        '<a class="thumb-video__avatar visible-xs" href="' + (dataVideo.series.length > 0 ? dataVideo.series[0].url : dataVideo.channelURL) + '">' +
        '<img name="thumb_mini" src="/images/avatar_square.png" width="35" height="35">' +
        '</a>' +
        '<div class="thumb-video__meta">' +
        '<h3><a name="title" href=""></a></h3>';
    if (dataVideo.series.length > 0) {
        videoHtml += '<a class="info-uploader" href="' + dataVideo.series[0].url + '"><span class="icon-series"></span>&nbsp;' + dataVideo.series[0].name + '</a>';
    } else {
        videoHtml += '<a class="info-uploader" href="' + dataVideo.channelURL + '"><span class="icon-user-1"></span>&nbsp;' + dataVideo.channelName + '</a>' +
            (dataVideo.channelVerified ? '<span class="icon-ok-circled icon"></span>' : '');
    }
    videoHtml += '<span class="views-number"><span class="icon-eye-1 icon"></span><span name="views"></span></span>' +
        '<button name="view-later" class="view-later view-later-real tooltips-botones">' +
        '        <span></span>' +
        '        <i class="icon-clock"></i>' +
        '    </button>' +
        '<div class="botones-edit-video">' +
        '<a class="btn btn-naranja tooltips-botones" name="url" href="">' +
        '<i class="icon-play icono"></i>' +
        '<span id="text-play-video">Play video</span>' +
        '</a>' +
        '<a class="btn tooltips-botones" name="url-edit" href="#">' +
        '<i class="icon-pencil icono"></i>' +
        '<span id="text-edit-video">Edit video</span>' +
        '</a>' +
        '</div>' +
        '<a href="#"' +
        'name="owner-video-show-modal"' +
        'class="btn btn-generico btn-mobile-vid owner-video-show-modal"' +
        'title="Video settings"' +
        'data-edit-video-url="#"' +
        'data-play-video-url="#"' +
        'data-highlight-url="#"' +
        'data-unhighlight-url="#"' +
        'data-ban-url="#">' +
        '<i class="icon icon-cog"></i>' +
        '</a>' +
        '</div>';

    var video = $(videoHtml);

    addVideoElementStatusClasses(video, dataVideo);

    $(video).find("[name='thumb']").attr('src', dataVideo.thumb);
    if (dataVideo.series.length > 0) {
        $(video).find("[name='thumb_mini']").attr('src', dataVideo.series[0].thumb);
        $(video).find("[name='thumb_mini']").attr('alt', dataVideo.series[0].name);
        $(video).find("[name='thumb_mini']").closest('a').addClass('thumb-video__avatar--serie');
    } else {
        $(video).find("[name='thumb_mini']").attr('src', dataVideo.thumb);
        $(video).find("[name='thumb_mini']").attr('alt', dataVideo.channelName);
    }

    $(video).find("[name='url']").attr('href', dataVideo.url);
    if (dataVideo.duration === '00:00') {
        $(video).find("[name='duration']").hide();
    } else {
        $(video).find("[name='duration']").text(dataVideo.duration);
    }
    $(video).find("[name='title']").html(dataVideo.title).attr('href', dataVideo.url);
    $(video).find("[name='date']").text(dataVideo.date);
    $(video).find("[name='views']").text(kFormat(parseInt(dataVideo.views ? dataVideo.views.replace(/[\.,\s]/g, '') : 0), 1));
    $(video).find("[name='comments']").text(dataVideo.comments);
    $(video).find("[name='url-edit']").attr('href', dataVideo.editUrl);
    $(video).find("[name='view-later']").attr('data-api-url', dataVideo.viewLaterAPIUrl);
    $(video).find("[name='view-later'] span").text($('.view-later:first span').text());
    $(video).find("[name='owner-video-show-modal']")
        .attr('data-play-video-url', dataVideo.url)
        .attr('data-edit-video-url', dataVideo.editUrl)
        .attr('data-highlight-url', dataVideo.highlightAPIUrl)
        .attr('data-unhighlight-url', dataVideo.unhighlightAPIUrl)
        .attr('data-ban-url', dataVideo.banAPIUrl)
        .click(function () {
            var modalContent = $('#videosettings');
            updateOwnerModalStatus($(this), modalContent);
            modalContent.remodal().open();
            return false;
        });

    if (!dataVideo.liveStream) {
        $(video).find("[name='live-video']").remove();
    }

    if (typeof global_tokyvideo_text_see_later != 'undefined') {
        $(video).find("#text-see-later").html(global_tokyvideo_text_see_later);
    }

    if (typeof global_tokyvideo_text_play_video != 'undefined') {
        $(video).find("#text-play-video").html(global_tokyvideo_text_play_video);
    }

    if (typeof global_tokyvideo_text_edit_video != 'undefined') {
        $(video).find("#text-edit-video").html(global_tokyvideo_text_edit_video);
    }

    return video;
}

function addVideoElementStatusClasses(video, dataVideo) {
    if (dataVideo.banned) {
        $(video).addClass('banned-video');
        $(video).find('.owner-video-show-modal').addClass('banned-video');
    }

    if (dataVideo.private) {
        $(video).find('.owner-video-show-modal').addClass('private');
    }

    if (dataVideo.admin) {
        $(video).find('.owner-video-show-modal').addClass('admin');
    }

    if (dataVideo.highlighted) {
        $(video).find('.owner-video-show-modal').addClass('highlighted');
    }
}

function createThumbOwnerPending(dataVideo) {
    var video = $('<div class="thumb-video thumb-video-pending">' +
        '<a name="url" href="#" class="thumb-duracion">' +
        '<img name="thumb" src="">' +
        '<div class="pending-icon tooltips-pending"><i class="icon-soccer-ball loadingball icon"></i> <span>' + global_tokyvideo_text_pending_word + '</span></div>' +
        '</a>' +
        '<h3><a name="title" href="#"></a></h3>' +
        '<p class="pending"><span class="icon-attention-1 icono"></span>' + global_tokyvideo_text_pending_phrase + '</p>' +
        '</div>');

    $(video).find("[name='thumb']").attr('src', dataVideo.thumb);
    $(video).find("[name='url'], [name='title']").attr('href', dataVideo.editUrl);
    $(video).find("[name='title']").html(dataVideo.title);

    if (dataVideo.showChannel && typeof global_tokyvideo_text_on != 'undefined') {
        var channel = $('<p> ' + global_tokyvideo_text_on + ' <a href="' + dataVideo.channelURL + '">' + dataVideo.channelName + '</a> <span class="icon-ok-circled icon"></span></p>');

        if (!dataVideo.channelVerified) {
            $(channel).find('span.icon-ok-circled').remove();
        }

        $(video).find('h3').after($(channel));
    }

    return video;
}

function createThumbOwnerIncomplete(dataVideo) {
    var video = $('<div class="thumb-video thumb-video-pending">' +
        '<a name="url" href="#" class="thumb-duracion">' +
        '<img name="thumb" src="">' +
        '<div class="pending-icon tooltips-pending"><i class="icon-soccer-ball loadingball icon"></i> <span>' + global_tokyvideo_text_incomplete_word + '</span></div>' +
        '</a>' +
        '<h3><a name="title" href="#"></a></h3>' +
        '<p class="pending"><span class="icon-attention-1 icono"></span>' + global_tokyvideo_text_incomplete_phrase + '</p>' +
        '</div>');

    $(video).find("[name='thumb']").attr('src', dataVideo.thumb);
    $(video).find("[name='url'], [name='title']").attr('href', dataVideo.editUrl);
    $(video).find("[name='title']").html(dataVideo.title);

    if (dataVideo.showChannel && typeof global_tokyvideo_text_on != 'undefined') {
        var channel = $('<p> ' + global_tokyvideo_text_on + ' <a href="' + dataVideo.channelURL + '">' + dataVideo.channelName + '</a> <span class="icon-ok-circled icon"></span></p>');

        if (!dataVideo.channelVerified) {
            $(channel).find('span.icon-ok-circled').remove();
        }

        $(video).find('h3').after($(channel));
    }

    return video;
}

function createThumbOwnerRejected(dataVideo) {
    var video = $('<div class="thumb-video thumb-video-pending">' +
        '<a name="url" href="#" class="thumb-duracion">' +
        '<img name="thumb" src="">' +
        '<div class="pending-icon tooltips-pending"><i class="icon-cancel-1 icon-no-animation"></i> <span>' + global_tokyvideo_text_rejected_word + '</span></div>' +
        '</a>' +
        '<h3><a name="title" href="#"></a></h3>' +
        '<p class="pending"><span class="icon-attention-1 icono"></span>' + global_tokyvideo_text_rejected_phrase + '</p>' +
        '</div>');

    $(video).find("[name='thumb']").attr('src', dataVideo.thumb);
    $(video).find("[name='url'], [name='title']").attr('href', dataVideo.editUrl);
    $(video).find("[name='title']").html(dataVideo.title);

    if (dataVideo.showChannel && typeof global_tokyvideo_text_on != 'undefined') {
        var channel = $('<p> ' + global_tokyvideo_text_on + ' <a href="' + dataVideo.channelURL + '">' + dataVideo.channelName + '</a> <span class="icon-ok-circled icon"></span></p>');

        if (!dataVideo.channelVerified) {
            $(channel).find('span.icon-ok-circled').remove();
        }

        $(video).find('h3').after($(channel));
    }

    return video;
}

function createThumbNotOwner(dataVideo) {
    var videoHtml = '<div class="thumb-video ' + element_class + '">' +
        '<a name="url" href="" class="thumb-duracion">' +
        '<img alt="'+ dataVideo.title +'" name="thumb" src=""  width="332px" height="186px">' +
        '<span class="duracion">' +
        '<span name="duration"></span>' +
        '</span>' +
        '</a>' +
        '<a class="thumb-video__avatar visible-xs" href="' + (dataVideo.series.length > 0 ? dataVideo.series[0].url : dataVideo.channelURL) + '">' +
        '<img name="thumb_mini" src="/images/avatar_square.png" width="35" height="35">' +
        '</a>' +
        '<div class="thumb-video__meta">' +
        '<h3><a name="title" href=""></a></h3>';
    if (dataVideo.series.length > 0) {
        videoHtml += '<a class="info-uploader" href="' + dataVideo.series[0].url + '"><span class="icon-series"></span>&nbsp;' + dataVideo.series[0].name + '</a>';
    } else {
        videoHtml += '<a class="info-uploader" href="' + dataVideo.channelURL + '"><span class="icon-user-1"></span>&nbsp;' + dataVideo.channelName + '</a>' +
            (dataVideo.channelVerified ? '<span class="icon-ok-circled icon"></span>' : '');
    }
    videoHtml += '<span class="views-number"><span class="icon-eye-1 icon"></span><span name="views"></span></span>' +
        '<button name="view-later" class="view-later view-later-real tooltips-botones">' +
        '        <span></span>' +
        '        <i class="icon-clock"></i>' +
        '    </button>' +
        '</div>';

    var video = $(videoHtml);

    $(video).find("[name='thumb']").attr('src', dataVideo.thumb);
    if (dataVideo.series.length > 0) {
        $(video).find("[name='thumb_mini']").attr('src', dataVideo.series[0].thumb);
        $(video).find("[name='thumb_mini']").attr('alt', dataVideo.series[0].name);
        $(video).find("[name='thumb_mini']").closest('a').addClass('thumb-video__avatar--serie');
    } else {
        $(video).find("[name='thumb_mini']").attr('src', dataVideo.thumb);
        $(video).find("[name='thumb_mini']").attr('alt', dataVideo.channelName);
    }

    $(video).find("[name='url']").attr('href', dataVideo.url);
    if (dataVideo.duration === '00:00') {
        $(video).find("[name='duration']").hide();
    } else {
        $(video).find("[name='duration']").text(dataVideo.duration);
    }

    $(video).find("[name='title']").html(dataVideo.title).attr('href', dataVideo.url);
    $(video).find("[name='date']").text(dataVideo.date);
    $(video).find("[name='views']").text(kFormat(parseInt(dataVideo.views ? dataVideo.views.replace(/[\.,\s]/g, '') : 0), 1));
    $(video).find("[name='comments']").text(dataVideo.comments);
    $(video).find("[name='view-later']").attr('data-api-url', dataVideo.viewLaterAPIUrl);
    $(video).find("[name='view-later'] span").text($('.view-later:first span').text());

    if (typeof global_tokyvideo_text_see_later != 'undefined') {
        $(video).find("#text-see-later").html(global_tokyvideo_text_see_later);
    }

    return video;
}
